// @ts-nocheck
import { hasNewVersion } from '@/components/Changelog/ChangelogStaticContent';
import { CHANGELOG_FILTER_ALL, CHANGELOG_FILTER_NEW, HIDE_CHANGELOG, SHOW_CHANGELOG } from '@/constants';

const initialState = {
    show: hasNewVersion(),
    filterLevel: CHANGELOG_FILTER_NEW,
};

const ChangelogReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SHOW_CHANGELOG:
            return {
                ...state,
                show: true,
                filterLevel: CHANGELOG_FILTER_ALL,
            };
        case HIDE_CHANGELOG:
            return {
                ...state,
                show: false,
            };
        default:
            return state;
    }
};

export default ChangelogReducer;
